import * as React from "react";

const GoogleRatingStars = ({ rating = 5, ...props }) => {
  const rounded = Math.round(rating * 10) / 10;

  switch (rounded) {
    case 5:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={135}
          height={25}
          className="rating-svg"
          viewBox="0 0 2700 492.289"
          role="img"
          aria-label="5 stars"
          {...props}
        >
          <defs>
            <linearGradient
              id="prefix__a"
              gradientUnits="userSpaceOnUse"
              x1={258.396}
              y1={19.906}
              x2={258.4}
              y2={416.813}
            >
              <stop offset={0} stopColor="#FFD433" />
              <stop offset={0.471} stopColor="#FABE2B" />
              <stop offset={1} stopColor="#F4A722" />
            </linearGradient>
          </defs>

          {[0, 540, 1080, 1620, 2160].map((x) => (
            <g key={x} transform={`translate(${x},0)`}>
              <path
                fill="url(#prefix__a)"
                d="M408.438 479.015l-28.808-168.89L498.73 188.3l-165.937-23.854L256.7 13.279l-76.805 151.167L13.284 188.3l119.503 121.825-27.827 168.89 151.74-81.162z"
              />
            </g>
          ))}
        </svg>
      );

    case 4.8:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={135}
          height={25}
          className="rating-svg"
          viewBox="0 0 2700 492.289"
          role="img"
          aria-label="4.8 stars"
          {...props}
        >
          <defs>
            <linearGradient
              id="prefix__a"
              gradientUnits="userSpaceOnUse"
              x1={258.396}
              y1={19.906}
              x2={258.4}
              y2={416.813}
            >
              <stop offset={0} stopColor="#FFD433" />
              <stop offset={0.471} stopColor="#FABE2B" />
              <stop offset={1} stopColor="#F4A722" />
            </linearGradient>

            <linearGradient id="fill80" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="80%" stopColor="#F0B100" />
              <stop offset="80%" stopColor="#ddd" />
            </linearGradient>
          </defs>

          {[0, 540, 1080, 1620].map((x) => (
            <g key={x} transform={`translate(${x},0)`}>
              <path
                fill="url(#prefix__a)"
                d="M408.438 479.015l-28.808-168.89L498.73 188.3l-165.937-23.854L256.7 13.279l-76.805 151.167L13.284 188.3l119.503 121.825-27.827 168.89 151.74-81.162z"
              />
            </g>
          ))}
          <g transform="translate(2160,0)">
            <path
              fill="url(#fill80)"
              d="M408.438 479.015l-28.808-168.89L498.73 188.3l-165.937-23.854L256.7 13.279l-76.805 151.167L13.284 188.3l119.503 121.825-27.827 168.89 151.74-81.162z"
            />
          </g>
        </svg>
      );

    default:
      return null;
  }
};

export default GoogleRatingStars;
